import dropWinsBadge from 'src/assets/images/badges/dropsAndWinsBadge.png';

export const DropWinsBadge = () => {
  return (
    <div className="absolute top-0 left-0 w-full z-[3] pr-[10%]">
      <img src={dropWinsBadge} alt="dropWinsBadge" className="h-auto w-[36px] 568:w-[70px] " />
    </div>
  );
};
